<template>
  <div class="composite-page composite-situation">
    <screen-panel :isExpand="isOpen" class="panel">
      <ScreenBoxClick title="人员信息" height="34%" menuCode="020102">
        <PeopleData :personData="personData"></PeopleData>
      </ScreenBoxClick>
      <ScreenBoxClick title="能耗统计" height="66%" menuCode="020104">
        <MonthUsePower title="前六月用电量" style="padding-top: 10px; height: 50%"></MonthUsePower>
        <MonthUseWater title="前六月用水量" style="padding-top: 10px; height: 50%"></MonthUseWater>
      </ScreenBoxClick>
    </screen-panel>
    <div class="top-bar">
      <div class="bar-list flex-center">
        <div class="list-item flex-center">
          <div class="item-left">
            <img src="~@src/common/assets/images/map/resource/situationA.png" />
          </div>
          <div class="item-right" @click="chartClick('030201')">
            <div class="title">今日安防告警数</div>
            <div class="value">{{ alarmData.todaySecurityAlarmCount }}</div>
          </div>
        </div>
        <!-- <div class="list-item flex-center">
          <div class="item-left">
            <img src="~@src/common/assets/images/map/resource/situationB.png" />
          </div>
          <div class="item-right">
            <div class="title">今日告警数</div>
            <div class="value">{{ alarmData.alarmTodayCount }}</div>
          </div>
        </div> -->
        <div class="list-item flex-center">
          <div class="item-left">
            <img src="~@src/common/assets/images/map/resource/situationC.png" />
          </div>
          <div class="item-right" @click="chartClick('030202')">
            <div class="title">今日已处理安防告警数</div>
            <div class="value">{{ alarmData.todaySecurityPendCount }}</div>
          </div>
        </div>
        <div class="list-item flex-center">
          <div class="item-left">
            <img src="~@src/common/assets/images/map/resource/situationD.png" />
          </div>
          <div class="item-right" @click="chartClick('030201')">
            <div class="title">未处理安防告警数</div>
            <div class="value">{{ alarmData.securityPendingCount }}</div>
          </div>
        </div>
      </div>

      <div class="bar-list flex-center">
        <div class="list-item flex-center">
          <div class="item-left">
            <img src="~@src/common/assets/images/map/resource/situationA.png" />
          </div>
          <div class="item-right" @click="chartClick('050501')">
            <div class="title">今日消防告警数</div>
            <div class="value">{{ alarmData.todayFireAlarmCount }}</div>
          </div>
        </div>
        <!-- <div class="list-item flex-center">
          <div class="item-left">
            <img src="~@src/common/assets/images/map/resource/situationB.png" />
          </div>
          <div class="item-right">
            <div class="title">今日告警数</div>
            <div class="value">{{ alarmData.alarmTodayCount }}</div>
          </div>
        </div> -->
        <div class="list-item flex-center">
          <div class="item-left">
            <img src="~@src/common/assets/images/map/resource/situationC.png" />
          </div>
          <div class="item-right" @click="chartClick('050504')">
            <div class="title">今日已处理消防告警数</div>
            <div class="value">{{ alarmData.todayFirePendCount }}</div>
          </div>
        </div>
        <div class="list-item flex-center">
          <div class="item-left">
            <img src="~@src/common/assets/images/map/resource/situationD.png" />
          </div>
          <div class="item-right" @click="chartClick('050501')">
            <div class="title">未处理消防告警数</div>
            <div class="value">{{ alarmData.firePpendingCount }}</div>
          </div>
        </div>
      </div>
    </div>
    <screen-panel :isExpand="isOpen" position="right" class="panel">
      <ScreenBoxClick title="车辆统计" height="40%" menuCode="020103">
        <CarStatics></CarStatics>
        <!-- <PeopleData :personData="personData"></PeopleData> -->
      </ScreenBoxClick>
      <ScreenBoxClick title="零碳主题态势统计" height="60%" menuCode="020107">
        <div class="box-top flex-row">
          <div class="item flex-row">
            <div class="item-icon">
              <img src="../../../../src/common/assets/images/用电量.png" alt="" />
            </div>
            <div class="item-content flex-valign">
              <div class="item-content_title">今日用电量</div>
              <div>
                <span class="item-content_value yellow-font">{{
                  energy.energyQuantity
                }}</span>
                <span class="unit-span">kW·h</span>
              </div>
            </div>
          </div>
          <div class="item flex-row">
            <div class="item-icon">
              <img src="../../../../src/common/assets/images/碳排放 .png" alt="" />
            </div>
            <div class="item-content flex-valign">
              <div class="item-content_title">今日碳排放量</div>
              <div>
                <span class="item-content_value green-font">{{
                  energy.carbonEmission
                }}</span>
                <span class="unit-span">tCO2e</span>
              </div>
            </div>
          </div>
          <!-- <div class="item-icon">
            <img src="../../../../src/common/assets/images/减排.png" alt="" />
          </div>
          <div class="item-content flex-row">
            <div class="item-content_title">碳排放统计</div>
            <div class="item-content_value">251</div>
            kg kg
          </div> -->
        </div>
        <div class="box-chart">
          <CarbonEmssionStatics></CarbonEmssionStatics>
        </div>

        <!-- <PeopleData :personData="personData"></PeopleData> -->
      </ScreenBoxClick>
    </screen-panel>
  </div>
</template>

<script>
import screenPanel from "../components/ScreenPanel.vue";
import PeopleData from "../components/PeopleData";
import MonthUsePower from "../components/MonthUsePower";
import MonthUseWater from "../components/MonthUseWater";
import CarStatics from "../components/CarStatics";
import CarbonEmssionStatics from "../components/CarbonEmssionStatics";
import API from "../api/index";
import ScreenBoxClick from "../components/ScreenBoxClick.vue";
import cacheKeys from "@/common/config/cacheKeys";
export default {
  data() {
    return {
      refMap: null,
      panelHeight: "calc(100% - 100px)",
      personData: {},
      alarmData: {
        alarmCount: 0,
        alarmTodayCount: 0,
        pendCount: 0,
        pendingCount: 0,
        todaySecurityAlarmCount: 0,
        todaySecurityPendCount: 0,
        securityPendingCount: 0,
        todayFireAlarmCount: 0,
        todayFirePendCount: 0,
        firePpendingCount: 0,
      },
      energy: {
        carbonEmission: 0,
        energyQuantity: 0,
      },
      isOpen: false,
    };
  },

  components: {
    screenPanel,
    PeopleData,
    MonthUsePower,
    MonthUseWater,
    CarStatics,
    CarbonEmssionStatics,
    ScreenBoxClick
  },

  // computed() {},
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D();
    this.queryAlarmData();
    this.queryCarbonByDay();
    this.isOpen = true;
  },

  methods: {
    addMenuFromLeftNav(menu) {
      let tabList = this.$store.getters.menuTabsList || [];
      if (!this.isExist(tabList, menu)) {
        tabList.push(menu);
        if (tabList.length > 10) {
          tabList.splice(0, 1);
        }
        this.$store.commit(cacheKeys.MENU_TABS_LIST, tabList);
      }
    },
    isExist(tabList, menu) {
      for (let i = 0; i < tabList.length; i++) {
        if (tabList[i].code === menu.code || tabList[i].path === menu.path) return true;
      }
      return false;
    },
    chartClick(menuCode) {
      let menu = {}
      this.$fetch(API.checkMenuPath, {
        "menuCode": menuCode
      }).then((res) => {
        if (res.success) {
          if (res.returnObj != null) {
            menu = {
              code: res.returnObj.menuCode,
              name: res.returnObj.menuName,
              path: res.returnObj.path,
              activePath: res.returnObj.path
            }
            this.addMenuFromLeftNav(menu)
            this.$router.push(menu.path)
          } else {
            this.$message.warning("无此功能权限，请联系管理员");
          }
        }
      });
    },
    queryAlarmData() {
      this.$fetch(API.statAlarmAllTotal, {}).then((res) => {
        if (res.success) {
          this.alarmData = res.returnObj;
        }
      });
    },
    queryCarbonByDay() {
      this.$fetch(API.carbonByLastDays, {}).then((res) => {
        if (res.success) {
          this.energy.carbonEmission = res.returnObj[res.returnObj.length - 1].carbonEmission.toFixed(2) || 0;
          this.energy.energyQuantity = res.returnObj[res.returnObj.length - 1].energyQuantity.toFixed(2) || 0;
          // console.log(res);
        }
      });
    },

    initPage() {
      this.refMap = this.$map.MapInstance2D;
      // 请求左侧列表
      // 初始化地图资源
      this.initMapResources();
      // 判断路由是否有参数
      //   if (!_.isEmpty(this.$route.query)) {
      //     this.handleClickAlarm(this.$route.query);
      //   }
    },
  },
};
</script>
<style lang='scss' scoped>
.margin-70 {
  margin-top: 70px;
}

.margin-10 {
  margin-top: 10px;
}

.top-bar {
  height: 164px;
  position: absolute;
  left: 470px;
  top: 0px;
  width: calc(100% - 940px);
  // background: linear-gradient(
  //   to right,
  //   rgba(13, 15, 22, 0.76) 0%,
  //   rgba(13, 15, 22, 0.456) 76%,
  //   rgba(13, 15, 22, 0) 100%
  // );
  background: linear-gradient(to right,
      rgba(13, 15, 22, 0) 0%,
      rgba(13, 15, 22, 0.456),
      rgba(13, 15, 22, 0) 100%);

  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  z-index: 2;

  .bar-list {
    margin-top: 20px;
    // color: #fff;
  }

  .list-item {
    margin-right: 42px;

    img {
      width: 40px;
    }

    .item-right {
      cursor: pointer;

      .title {
        // width: 80px;
        height: 28px;
        font-size: 20px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.8);
        line-height: 28px;
        -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }

      .value {
        font-size: 30px;
        font-weight: 700;
        margin-top: 8px;
        font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
        color: rgba(255, 255, 255, 0.9);
        text-align: center;
      }
    }

    .item-right:hover {
      .title {
        color: #409EFF;
      }

      .value {
        color: #409EFF;
      }
    }
  }
}

.box-top {
  height: 20%;
  @extend.margin-10;

  .item {
    width: 50%;
    margin: auto;
  }

  .item-content {
    padding: 0 7px;

    .unit-span {
      font-size: 18px;
      margin-left: 4px;
      color: rgba(255, 255, 255, 0.7);
    }

    &_title {
      font-size: 18px;
      // font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);
    }

    &_value {
      margin-top: 8px;
      font-size: 25px;
      font-weight: 900;
      color: rgba(255, 255, 255, 0.9);
      line-height: 34px;
      // text-shadow: 0px 1px 11px rgba(255, 196, 32, 0.6784);
      -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }

    .yellow-font {
      text-shadow: 0px 1px 11px rgba(255, 196, 32, 0.6784);
    }

    .green-font {
      text-shadow: 0px 1px 11px rgba(32, 255, 147, 0.6784);
    }
  }
}

.item-icon {
  img {
    width: 50px;
  }
}

.box-chart {
  // @extend.margin-10;
  height: 80%;
}

.panel {
  height: calc(100%);
}
</style>
